<template>
  <v-dialog v-model="dialog" max-width="620" persistent>
    <template v-slot:activator="{ on }">
      <v-btn
        fab
        x-small
        color="white"
        class="color-a"
        dark
        v-on="on"
        style="margin: 0 10px;"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="color-a">Lägg till ny beslutspunkt</v-card-title>
      <v-card-text>
        <decision-point-form
          ref="form"
          :weightedVoteOptional="weightedVoteOptional"
        ></decision-point-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Avbryt</v-btn>
        <v-btn text color="primary" type="submit" @click="create"
          >Lägg till</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DecisionPointForm from "@/components/decisionPoints/DecisionPointForm.vue";

export default {
  props: {
    meetingId: String,
    weightedVoteOptional: Boolean
  },
  components: { DecisionPointForm },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    close() {
      this.$refs.form.close();
      this.dialog = false;
    },
    async create() {
      let formData = { ...this.$refs.form.form };
      if (this.weightedVoteOptional && !formData.weightedVote) {
        formData.forceUnweighted = true;
      }
      delete formData.weightedVote;

      const success = await this.$store.dispatch(
        "meetings/createDecisionPoint",
        {
          meetingId: this.meetingId,
          ...formData
        }
      );
      if (success) {
        this.close();
      }
    }
  }
};
</script>

<style></style>
